exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-dd-menu{display:inline-block;width:auto}.wrap-dd-menu .dropdown:after,.wrap-dd-menu .dropdown:before{left:0;right:0;margin:auto;border-color:#267dc9 transparent}.wrap-dd-menu .dropdown{left:-30px;right:-30px;color:#fff;background-color:#267dc9;border-radius:0;font-weight:400;font-family:Roboto Condensed}.wrap-dd-menu .dropdown li a{display:block;padding:10px;text-decoration:none;color:inherit;border-bottom:1px solid rgba(0,0,0,.1);box-shadow:none;cursor:pointer;text-align:center}.wrap-dd-menu .dropdown li:hover a{background-color:#55c0ab;border-radius:0}", ""]);

// exports
